import { defineComponent } from '@nuxtjs/composition-api';

const __default__ = defineComponent({ head: {} });

import { computed } from 'vue';
import { useFetch, useContext } from '@nuxtjs/composition-api';
import { useBreadcrumbs, usePage } from '~/composables';


export default /*#__PURE__*/Object.assign(__default__, {
  __name: 'error',
  setup(__props) {

const useErrorPage = () => {
  const { i18n } = useContext();
  const { breadcrumbs, addCrumbs } = useBreadcrumbs();
  const { page, fetchPage } = usePage();

  useFetch(async () => {
    await fetchPage('404', {
      lang: i18n.locale,
    });
    addCrumbs('404');
  });

  const isCategoriesSection = computed({
    get() {
      return !!page?.value?.blocks?.find(
        (block) => block?.content?.type === 'categories-section',
      );
    },
    set() {},
  });

  return {
    isCategoriesSection,
    page,
    breadcrumbs,
  };
};

const { isCategoriesSection, page, breadcrumbs } = useErrorPage();

return { __sfc: true,useErrorPage, isCategoriesSection, page, breadcrumbs }
}

})